import type { ScreenModule } from "../../../app/screen-module";
import { HomePage } from "./Page";

const screenModule = {
	id: "end-user.home",
	path: "/app",
	area: "end-user",
	navGroup: "はたらく",
	label: "ホーム",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	demo: { allowed: true, constraints: ["no-persist"] },
	enabled: false,
	component: HomePage,
} satisfies ScreenModule;

export default screenModule;
